import { render, staticRenderFns } from "./Form.vue?vue&type=template&id=69f16464&scoped=true&"
import script from "./Form.vue?vue&type=script&lang=js&"
export * from "./Form.vue?vue&type=script&lang=js&"
import style0 from "./Form.vue?vue&type=style&index=0&id=69f16464&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69f16464",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/monbi/bbx/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69f16464')) {
      api.createRecord('69f16464', component.options)
    } else {
      api.reload('69f16464', component.options)
    }
    module.hot.accept("./Form.vue?vue&type=template&id=69f16464&scoped=true&", function () {
      api.rerender('69f16464', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/components/ui/forms/Form.vue"
export default component.exports